import { useState } from 'react';
import { Grid, MenuItem, SelectChangeEvent } from '@mui/material';
import SelectNoBorder from './SelectNoBorder';
import { Typography, colors } from '@sweep-io/sweep-design';

const CHEVRON_SIZE = {
  small: '12px',
  regular: '16px',
};

const useSortWidget = ({
  defaultValue,
  sortOptions,
  size = 'regular',
}: {
  defaultValue: string;
  sortOptions: string[];
  size?: 'small' | 'regular';
}) => {
  const [sortBy, setSortBy] = useState(defaultValue);

  const onChange = (e: SelectChangeEvent<unknown>) => {
    const value = e.target.value as string;
    setSortBy(value);
  };
  const isSmall = size === 'small';

  const SortWidget = (
    <Grid container width="auto" alignItems="center" flexWrap="nowrap" data-testid="sort-widget">
      <Typography variant={isSmall ? 'caption' : 'body'} color={colors.grey[700]}>
        Sort:
      </Typography>
      <Grid container justifyContent="flex-end">
        <SelectNoBorder
          value={sortBy}
          onChange={onChange}
          sx={{
            backgroundColor: 'transparent',
            minHeight: 'unset',
            '& .MuiSelect-select': {
              backgroundColor: 'transparent',
            },
            '& .MuiSelect-select.MuiOutlinedInput-input.MuiInputBase-input': {
              display: 'flex',
              alignContent: 'center',
              flexWrap: 'wrap',
              padding: '4px',
              paddingRight: `calc(${CHEVRON_SIZE[size]} + 4px)`,
              '.MuiTypography-root': {
                fontSize: isSmall ? '12px' : '14px',
              },
            },
            '.MuiSelect-icon': {
              top: isSmall ? '10px' : 'unset',
              width: CHEVRON_SIZE[size],
              height: CHEVRON_SIZE[size],
              right: 0,
            },
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            sx: {
              '.MuiMenu-paper': {
                width: '160px',
              },
            },
          }}
        >
          {sortOptions.map((option) => (
            <MenuItem key={option} value={option}>
              <Typography variant="body" color={colors.grey[900]}>
                {option}
              </Typography>
            </MenuItem>
          ))}
        </SelectNoBorder>
      </Grid>
    </Grid>
  );

  return { SortWidget, sortBy };
};

export default useSortWidget;
